import React from 'react';

/** État vide standard : icône discrète, titre, explication, action facultative. */
const EmptyState = ({ icon, title, description, action, className = '' }) => (
  <div className={`flex flex-col items-center justify-center px-6 py-14 text-center ${className}`}>
    {icon && (
      <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-surface-subtle text-ink-subtle">
        {icon}
      </div>
    )}
    <p className="text-sm font-semibold text-ink">{title}</p>
    {description && <p className="mt-1 max-w-sm text-xs text-ink-muted">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
